<template>
    <div class="card card-body date-range-slider">
        <vue-slider v-model="dateRange"
                    :min="min"
                    :max="max"
                    tooltip-dir="bottom"
                    :enable-cross=false
                    :clickable=false
                    height=2
                    :bg-style="{ backgroundColor: '#d5d6d7' }"
                    :slider-style="{ backgroundColor: 'black' }"
                    :process-style="{ backgroundColor: 'black' }"
                    :tooltip-style="{ backgroundColor: 'transparent', border: 'none transparent', color: 'black', marginTop: '-5px' }"
                    @drag-end="sendChangeNotification">
        </vue-slider>
    </div>
</template>

<script>
    import vueSlider from 'vue-slider-component';

    export default {
        components: {
            vueSlider
        },

        props: {
            min: { type: Number, required: true },
            max: { type: Number, required: true },
            start: { type: Number, required: true },
            end: { type: Number, required: true }
        },

        data() {
            return {
                dateRange: [this.start, this.end]
            }
        },

        mounted() {
            // send the initial state of the date range slider
            this.sendChangeNotification(false);
        },

        methods: {
            sendChangeNotification(onChange = true) {
                EventDispatcher.fire('dateRangeValueChanged', {
                    status: onChange ? 'changed' : 'initialized',
                    min: this.min,
                    max: this.max,
                    start: this.dateRange[0],
                    end: this.dateRange[1]
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .date-range-slider {
        background-color: #abbbbe;
        height: 4.5rem;
        margin: .5rem 0 1rem;

        .custom-tooltip {
            font-size: 0.875rem;
        }
    }
</style>